import { NaturezaAnalise } from "@/@types/NaturezaAnalise";
import { useAnaliseLaboratorial } from "@/hooks/useAnaliseLaboratorial";
import { useQuery } from "@tanstack/react-query";
import {
  Col,
  Divider,
  List,
  Modal,
  Row,
  Skeleton,
  Tag,
  Typography,
} from "antd";
import dayjs from "dayjs";

export function ModalHistoricoAnalise({
  open,
  onClose,
  naturezaAnalise,
  estabelecimentoId,
  produtoId,
}: {
  open: boolean;
  onClose: () => void;
  estabelecimentoId: number;
  produtoId?: number;
  naturezaAnalise: NaturezaAnalise;
}) {
  const { getHistoricoAnalisesApi } = useAnaliseLaboratorial();

  const {
    data: historicoAnalises,
    isLoading: isLoadingHistorico,
    isError,
  } = useQuery({
    queryKey: [
      "historico-analises",
      open,
      estabelecimentoId,
      produtoId,
      naturezaAnalise,
    ],
    queryFn: async () => {
      const result = await getHistoricoAnalisesApi({
        estabelecimentoId,
        produtoAutorizadoId: produtoId,
        naturezaAnaliseOficial: naturezaAnalise,
      });
      return result;
    },
    enabled: open,
  });

  return (
    <Modal
      title="Histórico de Análises Laboratoriais"
      open={open}
      onCancel={onClose}
      footer={null}
      width={1000}
      style={{ top: 20 }}
    >
      <Row style={{ maxHeight: 600, overflowY: "auto" }} gutter={[16, 16]}>
        {(historicoAnalises?.length === 0 || isError) && (
          <Col
            span={24}
            style={{ textAlign: "center", height: 100, paddingTop: 40 }}
          >
            <Typography.Text type="secondary">
              Nenhum histórico de análises encontrado.
            </Typography.Text>
          </Col>
        )}

        {isLoadingHistorico && <Skeleton active paragraph={{ rows: 10 }} />}

        <Col>
          {historicoAnalises?.map((analise) => {
            return (
              <Row key={analise.codigo} gutter={[8, 8]}>
                <Divider />

                <Col span={16}>
                  <Typography.Text strong>Código:</Typography.Text>
                  <Typography.Text type="secondary">
                    {" "}
                    {analise.codigo}
                  </Typography.Text>
                </Col>

                <Col span={8}>
                  <Typography.Text strong>Data Coleta:</Typography.Text>
                  <Typography.Text type="secondary">
                    {" "}
                    {dayjs(analise.dataColeta).format("DD/MM/YYYY HH:mm")}
                  </Typography.Text>
                </Col>

                <Col span={24}>
                  <Typography.Text strong>Produto:</Typography.Text>
                  <Typography.Text type="secondary">
                    {" "}
                    {analise.produto || "-"}
                  </Typography.Text>
                </Col>
                <Col span={16}>
                  <Typography.Text strong>Laboratorio:</Typography.Text>
                  <Typography.Text type="secondary">
                    {" "}
                    {analise.laboratorio || "-"}
                  </Typography.Text>
                </Col>

                <Col span={8}>
                  <Typography.Text strong>Código Laboratorio:</Typography.Text>
                  <Typography.Text type="secondary">
                    {" "}
                    {analise.codigoLaboratorio || "-"}
                  </Typography.Text>
                </Col>

                <Col span={24}>
                  <List
                    bordered
                    header={
                      <Row
                        style={{
                          width: "100%",
                        }}
                        gutter={[16, 16]}
                        align={"middle"}
                      >
                        <Col span={10}>
                          <Typography.Text strong>Ensaio</Typography.Text>
                        </Col>
                        <Col span={6} style={{ textAlign: "center" }}>
                          <Typography.Text strong>Resultado</Typography.Text>
                        </Col>
                        <Col span={4} style={{ textAlign: "center" }}>
                          <Typography.Text strong>Referência</Typography.Text>
                        </Col>
                        <Col span={4} style={{ textAlign: "center" }}>
                          <Typography.Text strong>Conforme</Typography.Text>
                        </Col>
                      </Row>
                    }
                    dataSource={analise.itens}
                    renderItem={(item) => (
                      <List.Item
                        style={{
                          backgroundColor:
                            item.resultado === null
                              ? "#FFFF"
                              : item.conforme
                                ? "#d2e0fa"
                                : "#fac8c3",
                        }}
                      >
                        <Row
                          style={{ width: "100%" }}
                          gutter={[16, 16]}
                          align={"middle"}
                        >
                          <Col span={10}>
                            <Typography.Text style={{ fontSize: 12 }}>
                              {item.ensaio}
                            </Typography.Text>
                          </Col>
                          <Col span={6} style={{ textAlign: "center" }}>
                            <Typography.Text style={{ fontSize: 12 }}>
                              {item.resultado}
                            </Typography.Text>
                          </Col>
                          <Col span={4} style={{ textAlign: "center" }}>
                            <Typography.Text style={{ fontSize: 12 }}>
                              {item.unidadeMedida}
                            </Typography.Text>
                          </Col>
                          <Col span={4} style={{ textAlign: "center" }}>
                            <Typography.Text style={{ fontSize: 12 }}>
                              {item.conforme === null
                                ? "-"
                                : item.conforme
                                  ? "Sim"
                                  : "Não"}
                            </Typography.Text>
                          </Col>
                        </Row>
                      </List.Item>
                    )}
                  />
                </Col>
                <Col>
                  <Typography.Text>Legenda:</Typography.Text>
                  <Tag
                    color="#d2e0fa"
                    style={{ marginLeft: 8, color: "#000000" }}
                  >
                    Conforme
                  </Tag>
                  <Tag
                    color="#fac8c3"
                    style={{ marginLeft: 8, color: "#000000" }}
                  >
                    Não Conforme
                  </Tag>
                </Col>
              </Row>
            );
          })}
        </Col>
      </Row>
    </Modal>
  );
}
